import { useShallow } from 'zustand/react/shallow';
import { useFormModalStore } from '~/stores';

export const useModal = () =>
	useFormModalStore(
		useShallow((state) => ({
			openFormModal: state.openFormModal,
			openDetailModal: state.openDetailModal,
			openConfirmModal: state.openConfirmModal,
			closeModal: state.closeModal,
			modalConfig: state.getCurrentModalConfig(),
		})),
	);
